import React from 'react';
import {Menu} from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';



export const StyledMenu = withStyles({
    paper: {
      color:'white',
      backgroundColor:'#212121',
      marginLeft:'1.5%'
    },
  })((props) => (
    <Menu
      elevation={0}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      {...props}
    />
  ));